import axios from 'axios';
import { UPDATE_STEP_TWO } from '../paths';

export const updateStep2 = async (data, courseID) => {
  const { trainer, image } = data;
  const body = new FormData();
  if (typeof image === 'object') {
    body.append('media', image);
  }
  body.append('courseID', courseID);
  body.append('teacherID', trainer._id);
  const response = await axios.post(UPDATE_STEP_TWO, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};
